import { getValidationErrors } from 'src/components/JobDatasheet/utils';
import { getValidationVariables } from 'src/utils/form/datasheet';

export default (question, questionResultsMap) => {
  const results = Array.from(questionResultsMap.keys()).map(datasheetQuestionId => ({
    datasheetQuestionId,
    result: questionResultsMap.get(datasheetQuestionId),
  }));
  const variables = getValidationVariables(results);
  const questionValidationErrors = getValidationErrors(question, variables, false);

  return questionValidationErrors;
};